import { render, staticRenderFns } from "./CollapseBox.vue?vue&type=template&id=714c7e09"
import script from "./CollapseBox.vue?vue&type=script&lang=js"
export * from "./CollapseBox.vue?vue&type=script&lang=js"
import style0 from "./CollapseBox.vue?vue&type=style&index=0&id=714c7e09&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports